import { createSlice } from "@reduxjs/toolkit";
import {
  loadThemeModeForUser,
  saveThemeModeForUser,
} from "../../utils/themeStorage";

const initialUser = JSON.parse(localStorage.getItem("user") || "null");

const initialState = {
  mode: loadThemeModeForUser(initialUser),
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setThemeMode(state, action) {
      state.mode = action.payload === "dark" ? "dark" : "light";
    },
    toggleThemeMode(state) {
      state.mode = state.mode === "dark" ? "light" : "dark";
    },
    syncThemeForUser(state, action) {
      state.mode = loadThemeModeForUser(action.payload);
    },
  },
});

export const { setThemeMode, toggleThemeMode, syncThemeForUser } =
  themeSlice.actions;

export const persistThemeMode = (mode) => (dispatch, getState) => {
  const nextMode = mode === "dark" ? "dark" : "light";
  dispatch(setThemeMode(nextMode));
  saveThemeModeForUser(getState().auth.user, nextMode);
};

export const toggleAndPersistTheme = () => (dispatch, getState) => {
  const nextMode = getState().theme.mode === "dark" ? "light" : "dark";
  dispatch(setThemeMode(nextMode));
  saveThemeModeForUser(getState().auth.user, nextMode);
};

export default themeSlice.reducer;
